var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.employees,"items-per-page":5,"multi-sort":true},on:{"click:row":_vm.selectRow}})}
var staticRenderFns = []

export { render, staticRenderFns }